import { graphql } from 'react-relay';

export const shoppingWithRoot = graphql`
    query shoppingWithRootQuery($urlLabel: String, $previewId: String, $isTrade: Boolean!) {
        viewer {
            ...ShoppingWithWrapper_viewer
            shoppingWith(urlLabel: $urlLabel, previewId: $previewId) {
                title
                mainImage
                items {
                    metaContentImage: firstPhotoWebPath(size: small)
                }
                ...ShoppingWithWrapper_shoppingWith
            }
        }
    }
`;
